import React, { useState } from 'react';
import './WalkThroughSection.css';

const WalkThroughSection = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  
  // YouTube video ID - extract from your YouTube URL
  // Example: https://www.youtube.com/watch?v=YOUR_VIDEO_ID
  const videoId = "YOUR_VIDEO_ID"; // Replace with your actual video ID
  
  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };
  return (
    <section className="walkthrough-section" id="walkthrough">
      <div className="container">
        <div className="walkthrough-layout">
          {/* Left Content */}
          <div className="walkthrough-content">
            <div className="walkthrough-header">
              <h2 className="walkthrough-title">
                Ansal Esencia <span className="highlight">Walk through</span>
              </h2>
            </div>

            {/* Video Container */}
            <div className="video-container">
              <div className="video-wrapper">
                {!isVideoLoaded && (
                  <div className="video-placeholder">
                    <div className="placeholder-content">
                      <div className="play-button">
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="12" fill="rgba(255, 255, 255, 0.9)"/>
                          <polygon points="10,8 16,12 10,16" fill="#FF0000"/>
                        </svg>
                      </div>
                      <p>Click to load video</p>
                    </div>
                  </div>
                )}
                <iframe
                  className={`video-iframe ${isVideoLoaded ? 'loaded' : ''}`}
                  src={`https://www.youtube.com/embed/f4bZt0GtAQY`}
                  title="Ansal Esencia Walkthrough Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  onLoad={handleVideoLoad}
                ></iframe>
              </div>
              
              <div className="video-info">
                <h3 className="video-title">Ansals Esencia Walkthrough - Esencia Sector 67, Gurgaon</h3>
                <p className="video-description">
                  Take a virtual tour of Ansal Esencia and explore the premium independent floors, 
                  modern amenities, and beautiful landscaping. See the actual construction progress 
                  and get a feel for the quality of construction and finishes.
                </p>
              </div>
            </div>
            {/* Video Statistics */}
            <div className="video-stats">
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-number">4.8/5</div>
                  <div className="stat-label">Project Rating</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Happy Families</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Construction Complete</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">2024</div>
                  <div className="stat-label">Possession Ready</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WalkThroughSection;